/**
 * Premium reader UI. Fully built since 41.1, waiting on the launch
 * flag. renderPremium receives dispatch text (markdown-lite) and
 * dresses it the way the printed premium insert is dressed: kicker,
 * drop rules, the fold, the seal line at the bottom.
 */

const KICKER = "Premium · Edition 41.2 · The sealed dispatch";

export function markdownLite(text: string): string {
  // The dispatch is plain text with simple conventions:
  //   lines starting "# " are headings
  //   lines starting "» " are pull quotes
  //   lines starting "— " are bylines/rules
  //   everything else is a paragraph
  const out: string[] = [];
  for (const rawLine of text.split(/\r?\n/)) {
    const line = rawLine.trimEnd();
    if (!line.trim()) continue;
    if (line.startsWith("# ")) out.push(`<h3 class="wire-premium__h">${esc(line.slice(2))}</h3>`);
    else if (line.startsWith("» ")) out.push(`<blockquote class="wire-premium__pull">${esc(line.slice(2))}</blockquote>`);
    else if (line.startsWith("— ")) out.push(`<p class="wire-premium__rule">${esc(line.slice(2))}</p>`);
    else out.push(`<p>${esc(line)}</p>`);
  }
  return out.join("\n");
}

function esc(s: string): string {
  return s.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
}

export function renderPremium(text: string): HTMLElement {
  const shell = document.createElement("div");
  shell.className = "wire-modal";
  shell.innerHTML = `
    <div class="wire-modal__scrim" data-close="1"></div>
    <div class="wire-modal__paper wire-premium" role="dialog" aria-modal="true">
      <button class="wire-modal__x" type="button" aria-label="Close" data-close="1">×</button>
      <div class="wire-premium__sheet">
        <p class="wire-premium__kicker">${KICKER}</p>
        <div class="wire-premium__body">${markdownLite(text)}</div>
      </div>
    </div>`;
  document.body.appendChild(shell);
  shell.addEventListener("click", (e) => {
    const t = e.target as HTMLElement;
    if (t.dataset.close) {
      shell.remove();
    }
  });
  const sketch = (window as unknown as { WireSketch?: { wireCard(el: HTMLElement): void } }).WireSketch;
  const paper = shell.querySelector<HTMLElement>(".wire-modal__paper");
  if (sketch && paper) sketch.wireCard(paper);
  return shell;
}
